/* eslint-disable max-len */
import { usersList } from "./apiSlice";

const reportsList = usersList.injectEndpoints({
    tagTypes: ['reports',],
    endpoints: (builder) => ({
        getDeviceReportList: builder.query({
            query: (searchParams) => ({
                url: `patients/list-device-alerts?${searchParams}`,
                method: 'GET',
               
            }),
            
        }),
        getProviderReportList: builder.query({
            query: (searchParams) => ({
                url: `patients/list-providers-alerts-report?${searchParams}`,
                method: 'GET',
               
            }),
        }),
    }),
   
    overrideExisting: false
})


export const {
    useGetDeviceReportListQuery,
    useGetProviderReportListQuery

} = reportsList